import { render, staticRenderFns } from "./recordother.vue?vue&type=template&id=4bbe2542&scoped=true&"
import script from "./recordother.vue?vue&type=script&lang=js&"
export * from "./recordother.vue?vue&type=script&lang=js&"
import style0 from "./recordother.vue?vue&type=style&index=0&id=4bbe2542&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe2542",
  null
  
)

export default component.exports